import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from '../../../Shared/Icon/Icon'

function LandingPageRules({ competitionTitle }) {
  return (
    <div className="row">
      <div className="col-12 col-sm-6 col-md-4 u-text-center">
        <Icon type={['fal', 'image']} color="green-dark" />
        <strong>Select</strong> a relevant category and enter your CG artwork.
      </div>
      <div className="col-12 col-sm-6 col-md-4 u-text-center">
        <Icon type={['fal', 'link']} color="green-dark" />
        <strong>Add a tag</strong> “Participant of <a href="https://www.cgtrader.com" className="link--primary-dark" target="_blank">CGTrader</a> {competitionTitle}”
        (with a clickable link to CGTrader's page) on your portfolio website.
        <Link to="/digital-art-competition/rules" className="btn btn-primary u-mt10">Read full rules</Link>
      </div>
      <div className="col-12 col-sm-6 col-md-4 u-text-center">
        <Icon type={['fal', 'list-alt']} color="green-dark" />
        <strong>Fill in</strong> the submission form and start competing for the prizes.
      </div>
    </div>
  )
}

LandingPageRules.propTypes = {
  competitionTitle: PropTypes.string.isRequired,
}

export default LandingPageRules
